import {Box, Icon, MenuItem, Select} from "@material-ui/core";
import React from "react";

const EditMediaType = (props) => {
  const {mediaTypes, onMediaTypeSelect, defaultValue, disabled} = props;

  const compareAndSortMediaTypes = (mediaTypes) => {
    const mediaTypePhotoList = {
      MEDIA_TYPE_PHOTO_DAMAGE: 1,
      MEDIA_TYPE_PHOTO_ACCIDENT_SCENE: 2,
      MEDIA_TYPE_PHOTO_DURING_REPAIR: 3,
      MEDIA_TYPE_PHOTO_AFTER_REPAIR: 4,
    };

    return mediaTypes.sort((firstMediaType, secondMediaType) => {
      const isFirstTypeDocument = firstMediaType.parent?.code === "MEDIA_TYPE_DOCUMENT";
      const isSecondTypeDocument = secondMediaType.parent?.code === "MEDIA_TYPE_DOCUMENT";

      if (!isFirstTypeDocument && isSecondTypeDocument ) {
        return 1;
      }
      if (isFirstTypeDocument && !isSecondTypeDocument) {
        return -1;
      }
      if (isFirstTypeDocument && isSecondTypeDocument) {
        return 0;
      }

      return (mediaTypePhotoList[firstMediaType.code] || Infinity) - (mediaTypePhotoList[secondMediaType.code] || Infinity);
    });
  }

  const sortedMediaTypes = compareAndSortMediaTypes([...mediaTypes]);

  const onChange = (event) => {
    onMediaTypeSelect(event.target.value);
  };
  return (
    <Select fullWidth onChange={onChange} value={defaultValue} disabled={disabled}>
      {sortedMediaTypes.map((mediaType) => (
        <MenuItem key={mediaType.id} value={mediaType.id}>
          <Box display="flex" alignItems="center">
            <Icon
              className={ mediaType.parent.code === "MEDIA_TYPE_DOCUMENT" ? "fas fa-file" : "fas fa-image"}
              fontSize="small"
            />
            - {mediaType.name}
          </Box>
        </MenuItem>
      ))}
    </Select>
  );

};

export default EditMediaType;